import React, { useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';

function TaxPopover({ onSubmit, onCancel, taxRow }) {
    const [selectedTaxType, setSelectedTaxType] = useState('');

    const handleRadioChange = (val) => setSelectedTaxType(val);

    useEffect(() => {
        setSelectedTaxType(taxRow?.tax_type)
    }, [taxRow])

    const handleSubmit = () => {
        onSubmit(selectedTaxType);
    };

    return (
        <Form>
        <div className="d-flex justify-content-start gap-2">
            <Form.Check
                type="radio"
                name="option"
                id="option1"
                value="Percentage"
                label="Percentage"
                checked={selectedTaxType === 'percentage'}
                onChange={() => handleRadioChange('percentage')}
                className="form-check-inline"
            />
            </div>
            <div className="d-flex justify-content-start gap-2">
                <button type="button" className="btn btn-primary btn-blue me-1"
                    onClick={handleSubmit}>
                    <span>Save</span>
                </button>
                <button type="button" className="btn btn-outline-primary btn-blue"
                    onClick={onCancel}>
                    <span>Cancel</span>
                </button>
            </div>
        </Form>
    );
}

export default TaxPopover;